import {
  BulkInviteImportPayloadUser,
  BulkInviteImportResponse,
  BulkInviteValidUser,
  BulkInviteValidationResponse,
} from '../model/bulkInviteTypes'

const isInviteCsvHeaderRow = (line: string): boolean => {
  const firstColumn = line.split(',')[0]?.trim().toLowerCase()
  return firstColumn === 'email'
}

export const countInviteCsvDataRows = (csvContent: string): number => {
  const nonEmptyLines = csvContent.split(/\r?\n/).filter(line => line.trim())

  if (!nonEmptyLines.length) {
    return 0
  }

  return isInviteCsvHeaderRow(nonEmptyLines[0]) ? nonEmptyLines.length - 1 : nonEmptyLines.length
}

export const mapValidUsersToImportPayload = (
  validUsers: BulkInviteValidUser[],
  botId: string
): BulkInviteImportPayloadUser[] => {
  return validUsers.map(user => ({
    email: user.email,
    first_name: user.firstName ?? user.first_name ?? '',
    last_name: user.lastName ?? user.last_name ?? '',
    role: user.role,
    manager_email: user.managerEmail ?? user.manager_email ?? null,
    botId: Number(botId),
  }))
}

export const isBulkInviteValidationResponse = (data: unknown): data is BulkInviteValidationResponse => {
  if (!data || typeof data !== 'object') {
    return false
  }

  const response = data as BulkInviteValidationResponse

  return (
    typeof response.totalRecords === 'number' &&
    typeof response.validRecords === 'number' &&
    typeof response.errorRecords === 'number' &&
    Array.isArray(response.validUsers) &&
    Array.isArray(response.errors)
  )
}

export const isBulkInviteImportResponse = (data: unknown): data is BulkInviteImportResponse => {
  if (!data || typeof data !== 'object') {
    return false
  }

  const response = data as BulkInviteImportResponse

  return (
    typeof response.totalRequested === 'number' &&
    typeof response.successfullyImported === 'number' &&
    typeof response.failed === 'number' &&
    Array.isArray(response.failedEmails)
  )
}

export const formatBulkInviteCellValue = (value: string | null | undefined): string => {
  if (!value || !value.trim()) {
    return ''
  }

  return value
}

export const isBulkInviteCellEmpty = (value: string | null | undefined): boolean => {
  return !value || !value.trim()
}
